var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.1332 5.89364C41.0398 4.80031 39.1465 5.54697 39.1465 7.06697V16.3736C39.1465 20.267 42.4532 23.4936 46.4798 23.4936C49.0132 23.5203 52.5332 23.5203 55.5465 23.5203C57.0665 23.5203 57.8665 21.7336 56.7998 20.667C52.9598 16.8003 46.0798 9.84031 42.1332 5.89364Z",
    fill: "#344054"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6665 27.173H46.9598C40.6398 27.173 35.4932 22.0263 35.4932 15.7063V7.99967C35.4932 6.53301 34.2932 5.33301 32.8265 5.33301H21.5198C13.3065 5.33301 6.6665 10.6663 6.6665 20.1863V43.813C6.6665 53.333 13.3065 58.6663 21.5198 58.6663H42.4798C50.6932 58.6663 57.3332 53.333 57.3332 43.813V29.8397C57.3332 28.373 56.1332 27.173 54.6665 27.173ZM30.6665 47.333H19.9998C18.9065 47.333 17.9998 46.4263 17.9998 45.333C17.9998 44.2397 18.9065 43.333 19.9998 43.333H30.6665C31.7598 43.333 32.6665 44.2397 32.6665 45.333C32.6665 46.4263 31.7598 47.333 30.6665 47.333ZM35.9998 36.6663H19.9998C18.9065 36.6663 17.9998 35.7597 17.9998 34.6663C17.9998 33.573 18.9065 32.6663 19.9998 32.6663H35.9998C37.0932 32.6663 37.9998 33.573 37.9998 34.6663C37.9998 35.7597 37.0932 36.6663 35.9998 36.6663Z",
    fill: "#344054"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentEmpty);
export default __webpack_public_path__ + "static/media/document-empty.ebd3757cb507e36dece8400340f9379c.svg";
export { ForwardRef as ReactComponent };